import LeftPointCard from "./LeftPointCard";
import RightRankingCard from "./RightRankingCard";

export default function LoyaltyPointSection() {
    return (
        <div
            className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 MuiGrid-item"
            style={{ marginBottom: "1px" }}
        >
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-5">
                <LeftPointCard />
            </div>

            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-7">
                <RightRankingCard />
            </div>
        </div>
    );
}